/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type {
  TemperatureJson,
} from '@/types/domain/temperature/entities/temperatureEntity';
import type { TemperatureStateType } from '@/types/domain/temperature/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: TemperatureStateType = {
  temperatureList: [],
  nextToken: null,
};

/**
 * 体温Slice
 */
export const temperatureSlice = createSlice({
  name: 'temperature',
  initialState,
  reducers: {
    /** 体温リストをセットする */
    setTemperatureList:
      (state, action: PayloadAction<{
        nextToken: string,
        items: TemperatureJson[],
      }>) => {
        state.temperatureList = action.payload.items;
        state.nextToken = action.payload.nextToken;
      },
    /** 体温ストア作成 */
    createTemperatureStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.temperatureList = service.temperature.createTemperatureStore(
        state.temperatureList,
        action.payload,
        undefined,
      );
    },
    /** 体温ストア更新 */
    updateTemperatureStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.temperatureList = service.temperature.updateTemperatureStore(
        state.temperatureList,
        action.payload,
      );
    },
    /** 体温ストア削除 */
    deleteTemperatureStore: (
      state,
      action: PayloadAction<DeleteOutputType>,
    ) => {
      state.temperatureList = service.temperature.deleteTemperatureStore(
        state.temperatureList,
        action.payload,
      );
    },
  },
});
